import { useQuery } from "@tanstack/react-query";
import { PaymentsFilters, PaymentsResponse } from "../types/payments";
import api from "../../../../lib/network/api";

// API function
export const getPayments = async (
  userId: string,
  filters?: PaymentsFilters
): Promise<PaymentsResponse> => {
  const params = new URLSearchParams();

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "" && value !== "all") {
        params.append(key, String(value));
      }
    });
  }

  const queryString = params.toString();
  const url = `/payments/${userId}${queryString ? `?${queryString}` : ""}`;

  const res = await api.get<{ data: PaymentsResponse }>(url);
  return res.data;
};

// Hook
export const useGetPayments = (
  userId: string | undefined,
  filters?: PaymentsFilters
) => {
  return useQuery<PaymentsResponse, Error>({
    queryKey: ["payments", userId, filters],
    queryFn: () => getPayments(userId as string, filters),
    enabled: !!userId,
  });
};
